// src/components/CrearHijoModal.js

import React, { useState } from 'react';
import apiClient from '../services/api';
import { toast } from 'react-toastify';
import Button from './Button';

function CrearHijoModal({ onClose, onHijoCreado }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica de espacios
    if (username.includes(' ')) {
        toast.warning("El nombre de usuario no puede tener espacios.");
        return;
    }

    try {
      // Enviamos solo lo que pide el ChildCreateSerializer
      await apiClient.post('/familia/ninos/', { 
        username, 
        password, 
        email: email || "" // Enviamos cadena vacía si no hay email
      });
      
      toast.success(`¡Cuenta de ${username} creada y activa!`);
      if (onHijoCreado) onHijoCreado();
      onClose();
    } catch (err) {
      console.error(err);
      let msg = "Error al crear la cuenta.";
      if (err.response?.data?.username) msg = `Usuario: ${err.response.data.username[0]}`;
      // Si el error es de otro tipo, mostramos el genérico
      toast.error(msg);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md transform transition-all scale-100">
        <h2 className="text-2xl font-bold text-principal mb-2">Añadir un Hijo/a 👶</h2>
        <p className="text-sm text-gray-500 mb-6">
          Esta cuenta se activará al instante y quedará vinculada a tu familia.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 font-bold mb-2">Nombre de Usuario</label>
            <input 
              type="text" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-principal" 
              required 
              placeholder="Ej. Pepito (Sin espacios)"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-gray-700 font-bold mb-2">Contraseña</label>
            <input 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-principal" 
              required 
              placeholder="Una clave sencilla"
            />
          </div>
          
          <div className="mb-6">
            <label className="block text-gray-700 font-bold mb-1">
              Email <span className="text-gray-400 font-normal text-sm">(Opcional)</span>
            </label>
            {/* MENSAJE SOLICITADO */}
            <p className="text-xs text-blue-600 mb-2 italic">
              Si tu hijo aún no tiene email, deja este campo vacío para que el sistema use automáticamente el tuyo para notificaciones.
            </p>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-principal" 
              placeholder="ejemplo@correo.com"
            />
          </div>
          
          <div className="flex justify-end gap-4 pt-4 border-t">
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" variant="accent">
              Crear Cuenta
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CrearHijoModal;